import { AlarmFromDatesType, AcknowledgeFilterType, AlarmContextModel } from '@shared/models';
import { createContext, Dispatch } from 'react';

export const AlarmsReducerDefaultValues = {
  from: AlarmFromDatesType.From3Months,
  acknowledge: AcknowledgeFilterType.All,
  showSystemAlarms: true,
} as AlarmContextModel;

export enum AlarmsActionType {
  SetFrom = 'SetFrom',
  SetAcknowledge = 'SetAcknowledge',
  SetShowSystemAlarms = 'SetShowSystemAlarms',
}

type State = AlarmContextModel;
type Action = {
  type: AlarmsActionType;
  payload: AlarmFromDatesType | AcknowledgeFilterType | boolean;
};

export const alarmsReducer = (state: State, action: Action): State => {
  const { type, payload } = action;
  switch (type) {
    case AlarmsActionType.SetFrom:
      return {
        ...state,
        from: payload as AlarmFromDatesType,
      };
    case AlarmsActionType.SetAcknowledge:
      return {
        ...state,
        acknowledge: payload as AcknowledgeFilterType,
      };
    case AlarmsActionType.SetShowSystemAlarms:
      return {
        ...state,
        showSystemAlarms: payload as boolean,
      };
    default:
      return state;
  }
};

export const AlarmsContext = createContext<{
  state?: State;
  dispatch?: Dispatch<Action>;
}>({});
